import React from 'react'
import {
  AccordionSummary,
  Typography,
  AccordionDetails,
  Accordion,
} from '@material-ui/core'
import { useStyles } from '../Styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FormTextField from '../../../../FormFields/FormTextField'

const Payment = ({ formClasses, data, formActions }) => {
  const classes = useStyles()
  return (
    <div className={classes.IssuerReceiverWrapper + ' row'}>
      <Accordion defaultExpanded={true} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          className={classes.IssuerReceiverHeaderWrapper}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.IssuerReceiverHeader}>
            <Typography className={classes.ItemHeading}>{data?.icon}{data?.title}</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.IssuerReceiverDetailsWrapper}>

          <FormTextField name={'bankName'}
                         labelKey={'Fields.label.bankName'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'bankAccountNo'}
                         labelKey={'Fields.label.bankAccountNo'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'swiftCode'}
                         labelKey={'Fields.label.swiftCode'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'bankAccountIBAN'}
                         labelKey={'Fields.label.bankAccountIBAN'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'bankAddress'} lines={3}
                         labelKey={'Fields.label.bankAddress'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'paymentTerms'} lines={3}
                         labelKey={'Fields.label.paymentTerms'} classes={formClasses}
                         formActions={formActions}/>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default Payment
